import { render, staticRenderFns } from "./CorrectOrderSlideOption.vue?vue&type=template&id=2482eb46&scoped=true"
import script from "./CorrectOrderSlideOption.vue?vue&type=script&lang=js"
export * from "./CorrectOrderSlideOption.vue?vue&type=script&lang=js"
import style0 from "./CorrectOrderSlideOption.vue?vue&type=style&index=0&id=2482eb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482eb46",
  null
  
)

export default component.exports